var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"mapState":'schoolRoutesMonitors',"allDispatch":'schoolRoutesMonitorsAll'}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc432f0c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/schoolroutes/monitors/list.vue
// module id = null
// module chunks = 